import React, { useState, useEffect, useContext } from 'react';
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import countries from './countries.json';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Swal from 'sweetalert2';
import { StoreContext } from '../../context/StoreContext';
import { CurrencyContext } from '../../context/CurrencyContext';  //Currency 
import { toast } from 'react-toastify';  
import { AuthContext } from '../authentication/AuthContext';
import TabbyBadge from '../../../public/assets/images/tabby-badge.svg';
import { Riple } from "react-loading-indicators";
import { FaCopy } from 'react-icons/fa';


const apiUrl = import.meta.env.VITE_API_URL;


const CheckoutSection = () => {
  const { t, i18n } = useTranslation(); 
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const { products, cart, removeFromCart } = useContext(StoreContext);
  const [subTotal, setSubTotal] = useState(0);
  const [countriesList, setCountriesList] = useState([]);
  const { selectedCurrency, value } = useContext(CurrencyContext); 
  const [shipping, setShipping] = useState(0);
  const [orderId, setOrderId] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [LimitofTabby, setLimitofTabby] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [addressId, setAddressId] = useState(null);
  const [shippingMethodId, setShippingMethodId] = useState(null);
    // const [userCountry, setUserCountry] = useState([]);
      const [userCountry, setUserCountry] = useState('');


    const saudiVariants = [
  'Saudi Arabia',
  'saudi arabia',
  'Kingdom of saudi arabia',
  'KSA',
  'SA',
  'المملكة العربية السعودية',
  'Kingdom of saudi arabia',
  'السعودية',
];

const isOutsideSaudi = !saudiVariants.includes(userCountry?.trim());


  

  useEffect(() => {
    // Extract addressId and shippingMethodId from URL params
    const params = new URLSearchParams(window.location.search);
    const addrId = params.get('address_id');
    const shipMethodId = params.get('shipping_method_id');

    if (addrId) setAddressId(addrId);
    if (shipMethodId) setShippingMethodId(shipMethodId);
  }, []);



  const [coupon, setCoupon] = useState({
    value: 0,
    type: '',
    id: '', 
  });
  const [couponCode, setCouponCode] = useState('');
  const [userData, setUserData] = useState({
    name: '',
    email: '',
    phone: '',
  });
  let currencyCode;

if (selectedCurrency === 'SAR') {
    currencyCode = 'SAR';
} else if (selectedCurrency === 'USD') {
    currencyCode = 'USD';
} else if (selectedCurrency === 'Euro') {
    currencyCode = 'EUR';
} else if (selectedCurrency === 'Pound') {
    currencyCode = 'GBP';
} else {
    currencyCode = 'Unknown'; // Default or error case
}

const useCoupon = async (couponCode) => {
  try {
    // Fetch coupon details
    const response = await axios.post(`${apiUrl}/api/use-coupon`, { code: couponCode }, {
      headers: { Authorization: `Bearer ${token?.token}` },
    });
    const data = response.data;

    // Fetch coupon brands from the backend
    const couponResponse = await axios.get(`${apiUrl}/api/coupons/${data.id}`, {
      headers: { Authorization: `Bearer ${token?.token}` },
    });

    const couponBrands = couponResponse.data.brands.map(brand => brand.id);
    const couponBrandDetails = couponResponse.data.brands; // تخزين تفاصيل العلامات

    // Get cart brand IDs
    const cartBrandIds = cart.map(item => products[item.product_id]?.brand_id).filter(Boolean);

    // Check if any cart brands are included in coupon brands
    const invalidBrands = cartBrandIds.filter(brandId => couponBrands.includes(brandId));
    if (invalidBrands.length > 0) {
      const invalidBrandId = invalidBrands[0]; // احصل على أول علامة تجارية غير صالحة
      const invalidBrandProduct = cart.find(item => products[item.product_id]?.brand_id === invalidBrandId);

      // تحقق مما إذا كان المنتج موجودًا
      if (invalidBrandProduct) {
        const invalidBrand = couponBrandDetails.find(brand => brand.id === invalidBrandId) || {};
        const brandName = invalidBrand.name_ar
          ? i18n.language === 'ar' ? invalidBrand.name_ar : invalidBrand.name_en
          : 'Unknown Brand';

        Swal.fire({
          icon: 'error',
          title: t('Oops...'),
          text: `${brandName} ${t('Brand is not included in this coupon!')}`,

        });
      } else {
        // إذا لم يتم العثور على المنتج، يمكنك عرض رسالة افتراضية
        Swal.fire({
          icon: 'error',
          title: t('Oops...'),
          text: t('This product is not found!'),
        });
      }
      return; // لا تسجل القسيمة في قاعدة البيانات
    }

    // If valid, store coupon data
    localStorage.setItem('coupon_id', String(data.id));
    setCoupon({
      value: data.value,
      type: data.type,
      id: data.id,
    });
    setCouponCode(couponCode);

    Swal.fire({
      title: t('Success!'),
      text: t('Coupon applied successfully!'),
      icon: 'success',
    });
  } catch (error) {
    console.error(error.response?.data);
    localStorage.removeItem('coupon_id');
    Swal.fire({
      icon: 'error',
      title: t('Oops...'),
      text: t('Invalid coupon code!'),
    });
  }
};


  const calculateDiscountAmount = (subTotal) => {
    let discountAmount = 0;
    if (coupon.value > 0) {
      if (coupon.type === 'percentage') {
        discountAmount = (subTotal * coupon.value) / 100;
      } else if (coupon.type === 'fixed') {
        discountAmount = coupon.value;
      }
    }
    return discountAmount;
  };
  


  useEffect(() => {
    const fetchUserData = async () => {
      if (!token) return; // Early return if token is not available
      try {
        const response = await axios.get(`${apiUrl}/api/user`, {
          headers: { Authorization: `Bearer ${token?.token}` },
        });
        const data = response.data;
        setUserData({
          name: data.name,
          email: data.email,
          phone: data.phone,
        });
        localStorage.setItem('userId', data.id);
      } catch (error) {
        console.error('Failed to fetch user data:', error);
        toast.error(t('Failed to fetch user information'));
      }
      finally {
        setLoading(false); // End loading
      }
    };
    
    if (token) {
      fetchUserData();
    }


  },
   [token, t]);
  //  if (loading) {
  //   return <Riple color="#5c5555" size="large" text="Loading" textColor="#000000" />;
  // }
useEffect(() => {
  const fetchAddress = async () => {
    const addressId = new URLSearchParams(window.location.search).get('address_id');
    if (!addressId) {
      console.warn('No address ID found in URL');
      return;
    }

    try {
      const response = await axios.get(`${apiUrl}/api/address/${addressId}`, {
        headers: {
          Authorization: `Bearer ${token?.token}`,
        },
      });

      const addressData = response.data;
      if (!addressData?.country) {
        console.warn('No country found in address data');
        return;
      }

      // const userCountry = addressData.country;
      // setUserCountry(userCountry);
      setUserCountry(String(addressData.country || '').trim());

    } catch (error) {
      console.error('Error fetching address:', error);
    }
  };

  fetchAddress();
}, [token, apiUrl]); // Added apiUrl as dependency


useEffect(() => {
  const fetchShippingPrice = async () => {
    if (!userCountry) {
      return; // Don't calculate shipping until country is available
    }

    try {
      // Calculate total cart value
      let totalCartValue = 0;
      cart.forEach((product) => {
        const productDetails = products[product.product_id];
        if (productDetails?.selling_price) {
          totalCartValue += product.quantity * productDetails.selling_price;
        }
      });

      // Determine shipping cost based on conditions
      let shippingCost; 

      // Check if address_id is 2
// if (addressId == 2) {
//   shippingCost = 0.00;
// } else if (isOutsideSaudi) {
//   if (totalCartValue < 5000) {
//     shippingCost = 150;
//   } else if (totalCartValue >= 5000 && totalCartValue < 10000) {
//     shippingCost = 100;
//   } else {
//     shippingCost = 0.00;
//   }
// } else {
//   if (totalCartValue < 5000) {
//     shippingCost = 50;
//   } else {
//     shippingCost = 0.00;
//   }
// }

if (addressId == 2) {
  shippingCost = 0.00;
} else if (isOutsideSaudi) {
  if (totalCartValue < 1200 && totalCartValue > 600 ) {
    shippingCost = 150;
  } else if (totalCartValue >= 1200 && totalCartValue < 10000) {
    shippingCost = 65;
  } else if (totalCartValue < 600) {
    shippingCost = 200;
  } 
  else if (totalCartValue >= 10000) {
    shippingCost = 0.00;
  } else {
    shippingCost = 0.00;
  }
} else {
  if (totalCartValue < 1500) {
   // shippingCost = 24;
    shippingCost = 0.00;
  } else {
    shippingCost = 0.00;
  }
}


      setShipping(shippingCost);
    } catch (error) {
      console.error('Error calculating shipping:', error);
    }
  };

  fetchShippingPrice();
}, [cart, products, userCountry, addressId]); 


  useEffect(() => {
    setCountriesList(Object.keys(countries));
  }, []);

  useEffect(() => {
    let calculatedTotalPrice = 0;
    setLoading(true); // Start loading for calculations
    cart.forEach((product) => {
      const productDetails = products[product.product_id];
      
      if (productDetails && productDetails.selling_price) {
        calculatedTotalPrice += product.quantity * productDetails.selling_price ;
      }
    });
    console.log('Cart:', cart);
    console.log('Products:', products);
    console.log('Calculated Total Price:', calculatedTotalPrice);
    setSubTotal(calculatedTotalPrice);
    setLoading(false);
  }, [cart, products]);



  const handleChange = (event) => {
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
  };

  // // Tabby Integration start
  // Tabby Integration start
    const getTabbyCheckoutSession = async () => {
      // Prepare items from the cart
      const items = cart.map((product) => ({
        title: product.title_en || 'No Title', 
        description: product.description_en || 'No Description', 
        quantity: product.quantity,
        unit_price: product.selling_price, 
        discount_amount: (product.discount || 0),
        reference_id: product.reference_id || "default_ref_id", 
        image_url: product.image_url || "http://example.com/default.jpg", 
        product_url: product.product_url || "http://example.com", // Default product URL
        gender: product.gender || "Unspecified", // Default gender
        category: product.category || "General", // Default category
        color: product.color || "N/A", // Default color
        product_material: product.material || "N/A", // Default material
        size_type: product.size_type || "N/A", // Default size type
        size: product.size || "N/A", // Default size
        brand: product.brand || "N/A" // Default brand
      }));
    
      const data = {
        payment: {
          amount: total.toString(), // Ensure this is a string
          currency: 'SAR',
          description: 'Your payment description here', // Add a meaningful description
          buyer: {
            phone: userData.phone || '', // Fallback to empty string if phone is not provided
            email: userData.email || '', // Fallback to empty string if email is not provided
            name: userData.name || 'Anonymous', // Default name
            dob: userData.dob || '', // Add date of birth if available
          },
          buyer_history: {
            registered_since: userData.registered_since || new Date().toISOString(), // Default to now if not provided
            loyalty_level: userData.loyalty_level || 0, // Default loyalty level
            wishlist_count: userData.wishlist_count || 0, // Default wishlist count
            is_social_networks_connected: userData.is_social_networks_connected || false,
            is_phone_number_verified: userData.is_phone_number_verified || false,
            is_email_verified: userData.is_email_verified || true,
          },
          order: {
            tax_amount: '0.00', // Add tax amount if applicable
            shipping_amount: shippingMethodId === '2' ? '50.00' : '0.00', 
            discount_amount: calculateDiscountAmount(), // Ensure this calculates discount dynamically
            updated_at: new Date().toISOString(), // Current date and time
            reference_id: `ref_${Date.now()}`, // Unique reference ID using current timestamp
            items: items,
          },
          order_history: [], // Fill this if you have order history
          shipping_address: {
            city: userData.city || 'Default City',
            address: userData.address || 'Default Address',
            zip: userData.zip || 'Default Zip',
          },
          meta: {
            order_id: '#1234', // Set your order ID here
            customer: '#customer-id', // Set customer ID here
          },
          attachment: {
            body: JSON.stringify({
              flight_reservation_details: {
                pnr: "TR9088999",
                itinerary: [],
                insurance: [], 
                passengers: [], 
                affiliate_name: "some affiliate"
              }
            }),
            content_type: "application/vnd.tabby.v1+json"
          }
        },
        lang: 'ar', // Change as needed
        merchant_code: 'RES', // Use the correct merchant code
        merchant_urls: {
        success: `https://regaleyes.sa/checkout?address_id=${addressId}&shipping_method_id=${shippingMethodId}`,
        cancel: `https://regaleyes.sa/checkout?address_id=${addressId}&shipping_method_id=${shippingMethodId}`,
        failure: `https://regaleyes.sa/checkout?address_id=${addressId}&shipping_method_id=${shippingMethodId}`,
        },
      };
    
      console.log('Request Data:', JSON.stringify(data, null, 2));
      
      try {
        const response = await axios.post(`${apiUrl}/api/tabby/create-checkout`, data, {
          headers: {
            Authorization: `Bearer ${token?.token}`,
          },
        });
      
        // Log the full response for debugging
        
        // Extract the session ID and store it for the next step
        const sessionId = response.data.payment.id; // Store the session ID
        let redirect_url;
        if(response.data.configuration.available_products!=""){
         redirect_url= response.data.configuration.available_products.installments[0].web_url
        }
        if(response.data.rejection_reason_code){
          setLimitofTabby(true);
        }
        console.log('API Response:', response.data.rejection_reason_code);
       
  
  
        return { sessionId, redirect_url}; // Return the session ID and API URL
      } catch (error) {
        console.error('Error fetching Tabby checkout session:', {
          message: error.message,
          response: error.response ? error.response.data : 'No response',
          requestData: data, // Log the request data for reference
        });
        throw error; // Rethrow the error for further handling
      }
    };
    
  
  const postTabbyOrder = async () => {
    if(selectedPaymentMethod===3){
      
      const { sessionId , redirect_url} = await getTabbyCheckoutSession();

      if (sessionId) {
        
         try {
          const response = await axios.post(`${apiUrl}/api/order/store-tabby-order`, {
            
          
            payment_id: sessionId,  // Ensure payment_id is included here
            // other order data
          }, {
            headers: {
              Authorization: `Bearer ${token?.token}`,
            },
          });
          if(redirect_url){
            window.location.href=redirect_url
          }
          
          
         return response
        } catch (error) {
         return error;
        }
      }
      

    }else{
      try {
        const response = await axios.post(`${apiUrl}/api/order/store-tabby-order`, {
          
        
          payment_id: selectedPaymentMethod,  // Ensure payment_id is included here
          // other order data
        }, {
          headers: {
            Authorization: `Bearer ${token?.token}`,
          },
        });
        
        console.log('Order posted successfully:', response.data);
      } catch (error) {
        console.error('Error posting Tabby order:', error.response.data);
      }

    }
   
  
  };
  

    

  // Tabby Integration end

  const getCartIdFromApi = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/cart`, {
        headers: {
          Authorization: `Bearer ${token?.token}`,
        },
      });
  
      const cartData = response.data;
      if (Array.isArray(cartData) && cartData.length > 0) {
        return cartData.map(cartItem => cartItem.id); // Return array of cart IDs
      }
    } catch (error) {
      console.error(error);
      // return null;
      return [];
    }
  };

  const total = (subTotal + +shipping - +calculateDiscountAmount(subTotal)).toFixed(2);


 const tabbySnippet = () => {
  console.log(total);
  localStorage.setItem("total",total)
  new TabbyCard({
    selector: '#tabbyCard',
    currency: 'SAR',
    lang: i18n.language,
    price: total,
    size: 'narrow',
    theme: 'black',
    header: false,
  });
};

  
    useEffect(() => {
      if (selectedPaymentMethod === 3) {
        localStorage.setItem('total',total)
        tabbySnippet();
      }
    }, [selectedPaymentMethod, total]);
  
useEffect(() => {
  if (selectedPaymentMethod === 2) {
    const fetchPaymobClientSecret = async () => {
      try {
        // Calculate discount and total
        const discountAmount = calculateDiscountAmount(subTotal);
        const totalAmount = (subTotal + Number(shipping) - discountAmount).toFixed(2) * 100; // Total in cents

        // Calculate total product amount before discount
        const totalProductAmount = cart.reduce((sum, product) => {
          const productDetails = products[product.product_id];
          return sum + (productDetails?.selling_price || 0) * (product.quantity || 1);
        }, 0);

        // Calculate discount distribution ratio
        const discountRatio = totalProductAmount > 0 ? (totalProductAmount - discountAmount) / totalProductAmount : 1;

        // Create items array
        const items = cart.map((product) => {
          const productDetails = products[product.product_id];
          const originalAmount = (productDetails?.selling_price || 0) * (product.quantity || 1) * 100; // Original amount in cents
          const discountedAmount = Math.round(originalAmount * discountRatio); // Apply discount proportionally
          const fallbackDescription = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.`;
          let finalDescription = productDetails?.description_en || fallbackDescription;

            if (finalDescription.length > 255) {
          finalDescription = finalDescription.slice(0, 255);
          }


          return {
            name: productDetails?.title_en || 'Unknown Item',
            amount: discountedAmount, // Discounted amount in cents
            // description: productDetails?.description_en || 'No Description',
              description: finalDescription,
            quantity: product.quantity || 1,
          };
        });

        // Add shipping as a separate item if applicable
        if (Number(shipping) > 0) {
          items.push({
            name: 'Shipping Fee',
            amount: Number(shipping) * 100, // Shipping in cents
            description: 'Shipping cost for the order',
            quantity: 1,
          });
        }

        // Calculate items total for validation
        const itemsTotal = items.reduce((sum, item) => sum + (item.amount * item.quantity), 0);

        // Validate that items total matches the total amount
        if (itemsTotal !== totalAmount) {
          console.error('Items total does not match total amount:', { itemsTotal, totalAmount });
          Swal.fire({
            icon: 'error',
            title: t('Payment Error'),
            text: t('Order total mismatch. Please review your cart and try again.'),
          });
          return;
        }

        // Log for debugging
        console.log('Items:', items);
        console.log('Items Total (cents):', itemsTotal);
        console.log('Total Amount (cents):', totalAmount);

        const response = await axios.post(`${apiUrl}/api/paymob-create-payment`, {
          billing_data: {
            first_name: userData.name || 'Unknown',
            last_name: userData.name || 'Unknown',
            email: userData.email || 'default@example.com',
            phone_number: userData.phone || '+966000000000',
            city: userData.city || 'Unknown',
            country: userData.country || 'N/A',
            street: userData.street || 'Unknown',
            building: 'Unknown',
            apartment: userData.apartment || 'N/A',
            floor: 'Unknown',
            state: userData.state || 'N/A',
          },
          amount: totalAmount, // Total in cents
          currency: 'SAR',
          items,
          extras: { ee: 22 },
          notification_url: 'https://webhook.site/dabe4968-5xxxxxxxxxxxxxxxxxxxxxx',
          redirection_url: `https://regaleyes.sa/checkout?address_id=${addressId}&shipping_method_id=${shippingMethodId}`,
        }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token?.token}`,
          },
        });

        const { client_secret, order_id } = response.data.data;
        if (!client_secret || !order_id) {
          throw new Error('Missing client_secret or order_id');
        }

        localStorage.setItem('paymobOrderId', order_id);

        const loadPixel = () => {
          const Pixel = window.Pixel;
          if (Pixel) {
            let container = document.getElementById('paymob-elements');
            if (!container) {
              container = document.createElement('div');
              container.id = 'paymob-elements';
              document.querySelector('.payment-info')?.appendChild(container);
            }

            new Pixel({
              publicKey: import.meta.env.VITE_PAYMOB_PUBLIC_KEY,
              clientSecret: client_secret,
              paymentMethods: ['card', 'apple-pay'],
              elementId: 'paymob-elements',
              customStyle: {
                Font_Family: 'Gotham',
                Font_Size_Label: '16',
                Font_Size_Input_Fields: '16',
                Font_Size_Payment_Button: '14',
                Amount_CurrencyCode: 'SAR',
                Amount_Value: totalAmount,
              },
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: t('Payment Initialization Failed'),
              text: t('Paymob payment widget could not be loaded.'),
            });
          }
        };

        loadPixel();
      } catch (error) {
        console.error('Error fetching Paymob client secret:', error.response?.data || error.message);
        Swal.fire({
          icon: 'error',
          title: t('Payment Initiation Failed'),
          text: error.response?.data?.message || t('Failed to initialize payment. Please try again later.'),
        });
      }
    };

    fetchPaymobClientSecret();
  }
}, [selectedPaymentMethod, userData, cart, products, subTotal, shipping, t, apiUrl, addressId, shippingMethodId]);
// useEffect(() => {
//   if (selectedPaymentMethod === 2) {
//     const fetchPaymobClientSecret = async () => {
//       try {
//       const discountAmount = calculateDiscountAmount(subTotal);
//       const totalAmount = (subTotal + +shipping - +discountAmount).toFixed(2) * 100; // Convert to the smallest currency unit (e.g., cents)

//         const items = cart.map((product) => ({
//           name: products[product.product_id]?.title_en || 'Unknown Item',
//            amount: (products[product.product_id]?.selling_price || 0) * product.quantity * 100, 
//           description: products[product.product_id]?.description_en || 'No Description',
//           quantity: product.quantity || 1,
//         }));
//         const response = await axios.post(`${apiUrl}/api/paymob-create-payment`, {
//           billing_data: {
//             first_name: userData.name || 'Unknown',
//             last_name: userData.name || 'Unknown',
//             email: userData.email || 'default@example.com',
//             phone_number: userData.phone || '+966000000000',
//             city: userData.city || 'Unknown',
//             country: userData.country || 'N/A',
//             street: userData.street || 'Unknown',
//             building: 'Unknown',
//             apartment: userData.apartment || 'N/A',
//             floor: 'Unknown',
//             state: userData.state || 'N/A',
//           },
//           amount: total * 100,
//           currency: 'SAR',
//           items,
//           extras: { ee: 22 },
//           notification_url: 'https://webhook.site/dabe4968-5xxxxxxxxxxxxxxxxxxxxxx',
//           redirection_url: `http://localhost:5173/checkout?address_id=${addressId}&shipping_method_id=${shippingMethodId}`,
//         }, {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token?.token}`, // Add token if required by backend
//           },
//         });

//         const { client_secret, order_id } = response.data.data;
//         if (!client_secret || !order_id) {
//           throw new Error('Missing client_secret or order_id');
//         }

//         localStorage.setItem('paymobOrderId', order_id);

//         const loadPixel = () => {
//           const Pixel = window.Pixel;
//           if (Pixel) {
//             let container = document.getElementById('paymob-elements');
//             if (!container) {
//               container = document.createElement('div');
//               container.id = 'paymob-elements';
//               document.querySelector('.payment-info')?.appendChild(container); // Append to payment-info
//             }

//             new Pixel({
//               publicKey: import.meta.env.VITE_PAYMOB_PUBLIC_KEY,
//               clientSecret: client_secret,
//               paymentMethods: ['card', 'apple-pay'],
//               elementId: 'paymob-elements',
//               customStyle: {
//                 Font_Family: 'Gotham',
//                 Font_Size_Label: '16',
//                 Font_Size_Input_Fields: '16',
//                 Font_Size_Payment_Button: '14',
//                 Amount_CurrencyCode: 'SAR',
//                 Amount_Value: total * 100,
//               },
//             });
//           } else {
//             Swal.fire({
//               icon: 'error',
//               title: t('Payment Initialization Failed'),
//               text: t('Paymob payment widget could not be loaded.'),
//             });
//           }
//         };

//         loadPixel();
//       } catch (error) {
//         console.error('Error fetching Paymob client secret:', error.response?.data || error.message);
//         Swal.fire({
//           icon: 'error',
//           title: t('Payment Initiation Failed'),
//           text: error.response?.data?.message || t('Failed to initialize payment. Please try again later.'),
//         });
//       }
//     };

//     fetchPaymobClientSecret();
//   }
// }, [selectedPaymentMethod, userData, cart, products, total, t, apiUrl, addressId, shippingMethodId]);

const handleSubmit = async (event) => {
  event.preventDefault();

  const userId = localStorage.getItem('userId');
  const cartIds = await getCartIdFromApi();
  const shippingMethodId = new URLSearchParams(window.location.search).get('shipping_method_id');
  const addressId = new URLSearchParams(window.location.search).get('address_id');
  const paymentMethodId = selectedPaymentMethod;
  const couponId = localStorage.getItem('coupon_id') ? Number(localStorage.getItem('coupon_id')) : null;
  const notes = event.target.notes.value;

  const formData = new FormData();
  formData.append('user_id', userId);
  cartIds.forEach((id, index) => {
    formData.append(`cart_id[${index}]`, id);
  });
  formData.append('shipping_method_id', shippingMethodId);
  formData.append('address_id', addressId);
  formData.append('payment_method_id', paymentMethodId);
  if (couponId) formData.append('coupon_id', couponId);
  formData.append('total_price', (subTotal + +shipping - +calculateDiscountAmount(subTotal)).toFixed(2));
  formData.append('status', paymentMethodId === 1 || 4 ? '0' : '1');
  formData.append('notes', notes);
  if (userData.file) formData.append('file', userData.file);

  try {
    if (selectedPaymentMethod === 2) {
      // Add your Paymob payment logic here
    } else {
      const response = await axios.post(`${apiUrl}/api/add-order`, formData, {
        headers: {
          Authorization: `Bearer ${token?.token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response && response.data) {
        setOrderId(response.data.combined_order_id);
        Swal.fire({
          title: "Success!",
          text: "Your order is successfully placed!",
          icon: "success",
        });
        for (const product of cart) {
          if (product) {
            await removeFromCart(product);
          }
        }
        navigate('/thank-you');
      }
    }
  } catch (error) {
    console.error('Error posting order:', error.response ? error.response.data : error);
    Swal.fire({
      icon: "error",
      title: "Order Submission Failed",
      text: error.response?.data?.message || "Unexpected response from the server. Please try again later.",
    });
  }
};

  useEffect(() => {
  const handlePaymentCompletion = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('success');
    const txnResponseCode = urlParams.get('acq_response_code'); // Paymob-specific param
    const paymobOrderId = urlParams.get('order'); // Paymob order ID from callback
  //  setLoading(true);

    if (status === 'true' || txnResponseCode === 'APPROVED' && !hasFetched) {
      setHasFetched(true);

      // إعادة حساب total_price
      const calculatedTotalPrice = (subTotal + Number(shipping) - calculateDiscountAmount(subTotal)).toFixed(2);
      console.log('Calculated total_price:', calculatedTotalPrice, { subTotal, shipping, discount: calculateDiscountAmount(subTotal) });

      // التحقق من أن القيمة صحيحة
      if (!calculatedTotalPrice || calculatedTotalPrice <= 0) {
        console.error('Invalid total_price:', calculatedTotalPrice);
        Swal.fire({
          icon: 'error',
          title: t('Order Submission Failed'),
          text: t('Invalid order total. Please try again.'),
        });
        setLoading(false);
        return;
      }

      const userId = localStorage.getItem('userId');
      const cartIds = await getCartIdFromApi();
      const shippingMethodId = urlParams.get('shipping_method_id');
      const addressId = urlParams.get('address_id'); // استخدم address_id من URL بدلاً من localStorage
      const paymentMethodId = 2;
      const couponId = localStorage.getItem('coupon_id') ? Number(localStorage.getItem('coupon_id')) : null;

      const productsData = cart.map((product) => ({
        product_id: product.product_id,
        quantity: product.quantity,
      }));

      const currentYear = new Date().getFullYear();
      const orderNo = `0e-${currentYear.toString().slice(-2)}-${Math.floor(1000 + Math.random() * 9000)}`;

      // استخدام FormData لتتناسب مع handleSubmit
      const formData = new FormData();
      formData.append('user_id', userId);
      cartIds.forEach((id, index) => {
        formData.append(`cart_id[${index}]`, id);
      });
      formData.append('shipping_method_id', shippingMethodId);
      formData.append('address_id', addressId);
      formData.append('payment_method_id', paymentMethodId);
      if (couponId) formData.append('coupon_id', couponId);
      formData.append('total_price', calculatedTotalPrice);
      formData.append('status', '1');
      formData.append('order_no', orderNo);
      if (paymobOrderId) formData.append('paymob_order_id', paymobOrderId);
      formData.append('products', JSON.stringify(productsData));

      try {
        const responseOrder = await axios.post(`${apiUrl}/api/add-order`, formData, {
          headers: {
            Authorization: `Bearer ${token?.token}`,
            'Content-Type': 'multipart/form-data',
          },
        });

        if (responseOrder.data) {
          setOrderId(responseOrder.data.combined_order_id);
          Swal.fire('Payment Successful', t('Your payment was completed successfully'), 'success');
          for (const product of cart) {
            await removeFromCart(product);
          }
          localStorage.removeItem('paymobOrderId');
          navigate('/thank-you');
        }
      } catch (error) {
        console.error('Error posting order:', error.response?.data || error);
        Swal.fire({
          icon: 'error',
          title: t('Order Submission Failed'),
          text: error.response?.data?.message || t('Failed to process order. Please try again.'),
        });
      } finally {
        setLoading(false);
      }
    } else if (status && txnResponseCode !== 'APPROVED') {
      Swal.fire({
        icon: 'error',
        title: t('Payment Failed'),
        text: t('Payment was not successful. Please try again.'),
      });
      setLoading(false);
    }
  };

  if (cart.length && products && !hasFetched && subTotal > 0) {
    handlePaymentCompletion();
  }
}, [cart, products, hasFetched, subTotal, shipping, token, t, navigate, removeFromCart]);
// useEffect(() => {
//   const handlePaymentCompletion = async () => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const status = urlParams.get('success');
//     const txnResponseCode = urlParams.get('acq_response_code'); // Paymob-specific param
//     const paymobOrderId = urlParams.get('order'); // Paymob order ID from callback
//       setLoading(true);

//     if (status === 'true' || txnResponseCode === 'APPROVED' && !hasFetched) {
//       setHasFetched(true);
//         const userId = localStorage.getItem('userId');
//         const cartIds = await getCartIdFromApi();
//         const shippingMethodId = urlParams.get('shipping_method_id');
//         const addressId = localStorage.getItem('addressId');
//         const paymentMethodId = 2; 
//         const couponId = localStorage.getItem('coupon_id') ? Number(localStorage.getItem('coupon_id')) : null;

//         const productsData = cart.map((product) => ({
//             product_id: product.product_id,
//             quantity: product.quantity,
//         }));

//         let calculatedTotalPrice = (subTotal + +shipping - +calculateDiscountAmount(subTotal)).toFixed(2);


//         const currentYear = new Date().getFullYear();
//         const orderNo = `0e-${currentYear.toString().slice(-2)}-${Math.floor(1000 + Math.random() * 9000)}`;

//         const data = {
//             user_id: userId,
//             cart_id: cartIds,
//             shipping_method_id: shippingMethodId,
//             address_id: addressId,
//             payment_method_id: paymentMethodId,
//             coupon_id: couponId, 
//             products: productsData,
//             order_no: orderNo,
//             total_price: total,
//             status: '1', // Assuming '1' means successful payment
//         };

//         try {
//           const responseOrder = await axios.post(`${apiUrl}/api/add-order`, data, {
//                 headers: { Authorization: `Bearer ${token?.token}` },
//             });

//             if (responseOrder) {
//                 Swal.fire('Payment Successful', 'Your payment was completed successfully', 'success');
//                 navigate('/thank-you'); // Navigate to the thank you page
//             }
//         } catch (error) {
//             console.error('Error posting order:', error);
//             Swal.fire('Order Submission Failed', 'There was an error processing your order. Please try again later.', 'error');
//         }
//     } else {
//         Swal.fire('Payment Confirmation Failed', message, 'error');
//     }
//      setLoading(false); // End loading after processing the payment response

// };

//   if (cart.length && products && !hasFetched) {
//   handlePaymentCompletion();
//   }
// }, [cart, products, hasFetched]);







useEffect(() => {
  const fetchPaymentStatus = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentId = urlParams.get('payment_id');
    
    if (paymentId && !hasFetched) {  // Only run if not fetched before
      setHasFetched(true);  // Set flag to true to prevent re-running

      try {
        const responseSuccss = await axios.get(`https://app.regaleyes.sa/api/tabby/payment-status/${paymentId}`);
        
        if (responseSuccss?.data?.status === 'AUTHORIZED') {
          console.log("Payment Authorized", responseSuccss.data.status);

          const userId = localStorage.getItem('userId');
          const cartIds = await getCartIdFromApi();
          const shippingMethodId = urlParams.get('shipping_method_id');
          const addressId = localStorage.getItem('addressId');
          const paymentMethodId = 3;
          const couponId = localStorage.getItem('coupon_id') ? Number(localStorage.getItem('coupon_id')) : null;

          const productsData = cart.map((product) => ({
            product_id: product.product_id,
            quantity: product.quantity,
          }));

          let calculatedTotalPriceTabby=localStorage.getItem('total'); 

          const currentYear = new Date().getFullYear();
          const orderNo = `0e-${currentYear.toString().slice(-2)}-${Math.floor(1000 + Math.random() * 9000)}`;

          const data = {
            user_id: userId,
            cart_id: cartIds,
            shipping_method_id: shippingMethodId,
            address_id: addressId,
            payment_method_id: paymentMethodId,
            coupon_id: couponId, 
            products: productsData,
            order_no: orderNo,
            total_price: calculatedTotalPriceTabby,
            status:'1',
          };

          const responseOrder = await axios.post(`https://app.regaleyes.sa/api/add-order`, data, {
            headers: { Authorization: `Bearer ${token?.token}` },
          });

          if (responseOrder) {
            Swal.fire('Payment Successful', 'Your payment was completed successfully', 'success');
            navigate('/thank-you');
          }
        } else if (responseSuccss?.data?.status === 'REJECTED') {
          Swal.fire({
            icon: "error",
            title: "Order Submission Failed",
            text: "Unexpected response from the server. Please try again later.",
          });
        }
      } catch (error) {
        console.error('Error fetching payment status:', error);
      }
    }
  };

  // Ensure cart and products are loaded before calling fetchPaymentStatus
  if (cart.length && products && !hasFetched) {
    fetchPaymentStatus();
  }
}, [cart, products, hasFetched]);




  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/payment-methods`);
        const paymentMethods = response.data;
        setPaymentMethods(paymentMethods);
      } catch (error) {
        console.error(error);
      }
    };
    fetchPaymentMethods();
  }, []);

  return (
    <div className="container">
           {loading && (
        <div className="loading-overlay">
          <Riple color="#5c5555" size="large" text="Loading" textColor="#ffffff" />
        </div>
      )}
      <div className="fz-checkout">
        <form action="#" className="checkout-form" onSubmit={handleSubmit}>
          <div className="fz-billing-details">
            <div className="row gy-0 gx-3 gx-md-4">
              <h3 className="fz-checkout-title">{t('Billing & Shipping Details')}</h3>
              <div className="col-12 col-xxs-12">
                <Form.Control
                  type="text"
                  placeholder={t('Enter your name')}
                  name="name"
                  value={userData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-12">
                <Form.Control
                  type="email"
                  placeholder={t('Enter your email')}
                  name="email"
                  value={userData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-12">
                <Form.Control
                  type="text"
                  placeholder={t('Enter your phone number')}
                  name="phone"
                  value={userData.phone}
                  onChange={handleChange}
                  required
                />
              </div>





          <div className="col-12 additional-info">
  <label htmlFor="checkout-additional-info" className="fz-checkout-title">{t('Additional Information')}</label>
  <textarea name="notes" id="checkout-additional-info" placeholder={t('Notes about your order, e.g. special notes for delivery.')}></textarea>
</div>
        </div>
      </div>
      <div className="fz-checkout-sidebar">
        <div className="billing-summery">
          <h4 className="fz-checkout-title">{t('Billing & Shipping Summary')}</h4>
          <div className="cart-checkout-area">
          <ul className="checkout-summary">
    <li>
      <span className="checkout-summary__key">{t('Subtotal')}</span>
      <span className="checkout-summary__value"><span>{t(selectedCurrency)} </span> {(subTotal * value).toFixed(2)}</span>
    </li>
    <li>
      <span className="checkout-summary__key">{t('Shipping')}</span>
      <span className="checkout-summary__value"><span>{t(selectedCurrency)}  </span> {(shipping * value).toFixed(2)}</span>
    </li>
    <li>
      <span className="checkout-summary__key">{t('Coupon discount')}</span>
      <span className="checkout-summary__value">-<span>{t(selectedCurrency)}  </span> {calculateDiscountAmount(subTotal * value).toFixed(2)}</span>
    </li>
    <li className="cart-checkout-total">
      <span className="checkout-summary__key">{t('Tax')}</span>
      <span className="checkout-summary__value"><span>{t(selectedCurrency)} </span> {(subTotal * 0.15 * value).toFixed(2)}</span>
    </li>
    <li className="cart-checkout-total">
      <span className="checkout-summary__key">{t('Total')}</span>
      {t(selectedCurrency)}      {((subTotal + +shipping - +calculateDiscountAmount(subTotal)) * value).toFixed(2)}
    </li>
  </ul>


            <Link to="/cart" className="fz-1-banner-btn cart-checkout-btn">{t('Edit Order')}</Link>
            <div className="cart-coupon-form p-2">
  <input type="text" name="code" id="cart-coupon-input" placeholder="Enter Your Coupon Code" onChange={(e) => localStorage.setItem('coupon_code', e.target.value)} />
  <button 
  className="fz-1-banner-btn coupon-apply-btn" onClick={(e) => {
     e.preventDefault();
     const couponCode = localStorage.getItem('coupon_code') || '';

    // const couponCode = document.getElementById('cart-coupon-input').value;
     useCoupon(couponCode);
    
     
  }}>{t('Apply Coupon')}</button>
</div>
          </div>
        </div>
        <div className="payment-info">
          <h4 className="fz-checkout-title">{t('Payment Information')}</h4> 

          {paymentMethods.map((method, index) => {
            // Check if the shipping method is 2 and the payment method id is 1
            if (shippingMethodId === '2' && method.id === 1) {
              return null; // Skip rendering this payment method
            }
return (
    <div key={index}>
        <input
            type="radio"
            name="payment-method"
            value={method.id}
            checked={selectedPaymentMethod === method.id}
            onChange={() => setSelectedPaymentMethod(method.id)}
        />
        <span className="p-2">
            {i18n.language === 'ar' ? method.title_ar : method.title_en}
        </span>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            {method.image && method.image.split(',').map((image, imgIndex) => (
                <img 
                    key={imgIndex} 
                    src={`${apiUrl}/uploads/${image.trim()}`} 
                    alt="payment method" 
                    width="50" 
                    style={{ padding: '1px' }} 
                />
            ))}
        </div>
    </div>
);
          })}


{selectedPaymentMethod === 2 &&(
  <>
      <div id="paymob-elements" style={{ width: '100%' }}></div>
      
  </>
)}


{selectedPaymentMethod === 3 && (
  <>
    <input type="hidden" name="tabby_url" value={`${apiUrl}/tabby-checkout`}/>
    <img src={TabbyBadge} style={{ width: 80, height: 37 }} alt="Tabby Badge" />
    <span style={{ fontSize: 18, fontWeight: 'bolder' }}>
      {i18n.language === 'ar' ? 'قسّمها على 4. بدون أي فوائد، أو رسوم' : 'Pay in 4. No interest, no fees'}
    </span>
    <div className="p-3" id="tabbyCard"></div>
  </>
)}


{selectedPaymentMethod === 4 && (
  <div className="col-12">
    <p><strong>{t('Mawajed Trading Company')}</strong></p>
    <p><strong>{t('Aljazeera Bank')}</strong></p>
    <p><strong>{t('Swift Code')}: </strong>BJAZSAJE</p>
    <p>
    <strong>IBAN: </strong>SA5060100001695021479002
    <FaCopy
      style={{ marginLeft: '8px', cursor: 'pointer', color: '#555' }}
      onClick={() => {
        navigator.clipboard.writeText('SA5060100001695021479002');
        Swal.fire({
          icon: 'success',
          title: t('Copied!'),
          text: t('IBAN copied to clipboard'),
          timer: 1500,
          showConfirmButton: false,
        });
      }}
      title={t('Copy IBAN')}
    />
  </p>
  <p><strong>{t('Upload Transfer file')}</strong></p>

<br />
    <input
      type="file"
      id="payment-file"
      name="file"
      accept="image/*,application/pdf"
      onChange={(e) => setUserData({ ...userData, file: e.target.files[0] })}
      required
    />

<p><strong>{t('Note')}: </strong>{t('The order will be processed after the transfer has been confirmed')}</p>

  </div>
)}
          <p className="checkout-payment-descr">{t('Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our')} <a href="/privacy-policy">{t('privacy policy')}</a></p>
      
          {/* <button type="submit" className="fz-1-banner-btn cart-checkout-btn checkout-form-btn">{t('Place Order')}</button> */}
          {selectedPaymentMethod !== 2 && (
    <button type="submit" className="fz-1-banner-btn cart-checkout-btn checkout-form-btn">
      {t('Place Order')}
    </button>
  )}
  
        </div>
      </div>
    </form>
  </div>
</div>
);
};

export default CheckoutSection;